import React, { useState, useEffect } from "react";
import axios from "axios";

export default function Step13Medicine({ suggestedMedicine, onSelect }) {
const [selectedMed, setSelectedMed] = useState(() => {
  const saved = localStorage.getItem("selectedMedicine");
  return saved ? JSON.parse(saved) : null;
});

  const [medications, setMedications] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchMedications = async () => {
      setLoading(true);
      try {
        const baseUrl = process.env.REACT_APP_API_BASE_URL;
        const typeParam =
          suggestedMedicine.length === 2 ? "BOTH" : suggestedMedicine[0];

        const response = await axios.get(`${baseUrl}/stocks`, {
          params: { type: typeParam },
        });

        const availableMeds = response.data.map((med) => ({
          ...med,
          color:
            ["Mounjaro", "Phentermine"].includes(med.name)
              ? "purple"
              : "green",
        }));

        setMedications(availableMeds);
      } catch (error) {
        console.error("Error fetching medicines:", error);
        setMedications([]);
      } finally {
        setLoading(false);
      }
    };

    if (suggestedMedicine.length > 0) fetchMedications();
  }, [suggestedMedicine]);

 const handleSelect = (med) => {
  setSelectedMed(med);  // use object, not name string
  localStorage.setItem("selectedMedicine", JSON.stringify(med));

  if (onSelect) onSelect(med);  // pass full object to parent
};


  return (
    <div className="w-full max-w-2xl bg-white  shadow-sm pt-4 pb-8 px-6 relative ">
      <h2 className="text-[16px] font-medium text-[#000000] mb-4 text-center">
        Selected Medication
      </h2>

      {loading && <p className="text-center text-gray-500 py-6">Loading medicines...</p>}

      {!loading && medications.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-4">
          {medications.map((med) => (
            <button
              key={med.name}
              onClick={() => handleSelect(med)}
              className={`px-4 py-2 rounded border text-xs sm:text-sm ${
              selectedMed?.name === med.name
                  ? "border-blue-500 bg-blue-50 text-blue-700"
                  : "border-gray-300 bg-white text-black"
              }`}
            >
              {med.name} ({med.description})
            </button>
          ))}
        </div>
      )}

      <div className="flex items-center text-[12px] text-[#000000] mb-6">
        <span className="inline-flex items-center justify-center w-4 h-4 rounded-full border border-gray-400 text-[10px] mr-2">
          i
        </span>
        <span>You will be able to select the dosage before checkout</span>
      </div>

      {/* About Medication Dropdowns */}
      {medications.map((med) => (
        <div key={med.name} className="mb-2">
          <select
            className="w-full border border-gray-200 rounded-md bg-white px-4 py-3 text-sm text-[#000000] focus:outline-none"
          >
            <option value="">About {med.name}</option>
            <option value="what-is">What is {med.name}?</option>
            <option value="how-works">How does it work?</option>
            <option value="side-effects">Possible side effects</option>
          </select>
        </div>
      ))}

      <div className="flex items-center text-[11px] text-[#000000] mb-5">
        <span className="inline-flex items-center justify-center w-4 h-4 rounded-full border border-gray-400 text-[10px] mr-2">
          i
        </span>
        <span className="text-[12px]">Not sure what to select?</span>
      </div>
    </div>
  );
}
